var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        { attrs: { "no-body": "" } },
        [
          _c("b-card-header", [_c("b", [_vm._v("Groups")])]),
          _vm._v(" "),
          _vm.memberGroups.length > 0
            ? _c(
                "div",
                _vm._l(_vm.memberGroups, function(um) {
                  return _c(
                    "b-list-group",
                    { key: um.id, attrs: { flush: "" } },
                    [
                      _c("b-list-group-item", [
                        _vm._v(
                          "\n            " +
                            _vm._s(um.groupName) +
                            "\n          "
                        ),
                        um.defaultOrg === _vm.organizationId
                          ? _c("img", {
                              attrs: {
                                src: "static/img/Primary.png",
                                height: "21",
                                width: "21"
                              }
                            })
                          : _vm._e()
                      ])
                    ],
                    1
                  )
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.memberGroups.length === 0
            ? _c(
                "div",
                [
                  _c(
                    "b-list-group",
                    { attrs: { flush: "" } },
                    [
                      _c("b-list-group-item", [
                        _c("p", [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                !_vm.hasOrganizations
                                  ? "This Organization does not have any Groups."
                                  : "Howdy!"
                              ) +
                              "\n          "
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bbd32f12", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bbd32f12","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/OrganizationGroups.vue
// module id = 1857
// module chunks = 0